"use strict";

export const ActionType = {
  NONE: 0,
  REANIMATED_WORKLET: 1,
  NATIVE_ANIMATED_EVENT: 2,
  JS_FUNCTION_OLD_API: 3,
  JS_FUNCTION_NEW_API: 4,
  NATIVE_DETECTOR: 5,
  VIRTUAL_DETECTOR: 6
};

// eslint-disable-next-line @typescript-eslint/no-redeclare -- backward compatibility; it can be used as a type and as a value
//# sourceMappingURL=ActionType.js.map